import { gbp } from "@/lib/api";
import { BookingDialog } from "@/components/BookingDialog";
import { Button } from "@/components/ui/button";
import { MapPin, Moon, Check } from "lucide-react";

export const HolidayCard = ({ h }) => (
  <div data-testid={`holiday-card-${h.id}`} className="bg-white rounded-2xl border border-slate-200 overflow-hidden hover:-translate-y-1 hover:shadow-[0_12px_40px_rgb(11,60,93,0.12)] transition-all duration-300 flex flex-col">
    <div className="relative h-52">
      <img src={h.image} alt={h.title} className="w-full h-full object-cover" />
      <span className="absolute top-3 left-3 bg-[#FF6B35] text-white rounded-full px-3 py-1 text-xs font-bold uppercase tracking-wide">{h.category}</span>
      <span className="absolute bottom-3 left-3 bg-black/60 text-white rounded-full px-2.5 py-1 text-xs flex items-center gap-1"><Moon className="w-3 h-3" /> {h.nights} nights</span>
    </div>
    <div className="p-5 flex-1 flex flex-col">
      <h3 className="font-display font-semibold text-lg text-slate-900 leading-tight">{h.title}</h3>
      <p className="text-xs text-slate-400 flex items-center gap-1 mt-1"><MapPin className="w-3 h-3" /> {h.destination}, {h.country}</p>
      <ul className="mt-3 space-y-1 flex-1">
        {(h.includes || []).slice(0, 3).map((i) => (
          <li key={i} className="text-xs text-slate-600 flex items-center gap-1.5"><Check className="w-3.5 h-3.5 text-[#328CC1]" /> {i}</li>
        ))}
      </ul>
      <div className="flex items-end justify-between mt-4 pt-4 border-t border-slate-100">
        <div><p className="text-[11px] text-slate-400">{h.board} · pp from</p><p className="font-display text-2xl font-bold text-[#0B3C5D]">{gbp(h.price)}</p></div>
        <BookingDialog productType="holiday" item={h} unitPrice={h.price}
          trigger={<Button data-testid={`book-holiday-${h.id}`} className="rounded-full bg-[#FF6B35] hover:bg-[#e85a26] text-white font-semibold">Book</Button>} />
      </div>
    </div>
  </div>
);
